"use strict";

class SuperUnitCategoriesController {

    constructor(
        Upload,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSAppService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.unitCategories = null;

        self.unitCategoriesTotalCount = null;
        self.unitCategoriesPagesCount = null;

        self.unitCategoryParams = {
            pageNo: '1',
            offset: 0,
            limit: '20',
            send_total_count: true,
        };

        self.checked = 0;

        self.current = 1;
        self.jump_to_page = 1;

        self.selectedUnitCategory = null;
        self.unitCategoryViewMode = null;
        self.unitCategoryEditMode = null;

        self.getUnitCategories();

    }

    //-------------------------------------------

    getUnitCategories() {
        let self = this;

        let url = 'sec/super/unit-categories';

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.unitCategoryParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.unitCategories = response.data.unit_categories;
            self.unitCategoriesTotalCount = response.data.count;

            self.prepareUnitCategoriesPaginationData();
        });

    }

    prepareUnitCategoriesPaginationData() {
        const self = this;

        self.unitCategoriesPagesCount = Math.ceil(self.unitCategoriesTotalCount / self.unitCategoryParams.limit);

        self.unitCategoriesPagesArray = [];
        for (let i = 0; i < self.unitCategoriesPagesCount; i++) {
            self.unitCategoriesPagesArray.push(i + 1);
        }

        if (self.unitCategoriesPagesCount < self.unitCategoryParams.pageNo) {
            self.unitCategoryParams.pageNo = 1;
        }
    }

    setPageNoAndLoadUnitCategories(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.unitCategoryParams.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.unitCategoryParams.pageNo - 1;
            }

            if (pageNo > self.unitCategoriesPagesCount) {
                pageNo = self.unitCategoriesPagesCount;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.unitCategoryParams.pageNo) {
                return; // Ignore if no change
            }

            self.unitCategoryParams.pageNo = pageNo;
        }

        self.unitCategoryParams.offset = (self.unitCategoryParams.pageNo - 1) * self.unitCategoryParams.limit;

        self.getUnitCategories();
    }

    setLimitAndLoadUnitCategories() {
        const self = this;

        self.unitCategoryParams.pageNo = '1';
        self.unitCategoryParams.offset = 0;
        self.unitCategoryParams.send_total_count = 1;

        self.getUnitCategories();
    }

    setUnitCategoryViewMode(mode, unitCategory) {
        const self = this;

        if (mode) {

            self.selectedUnitCategory = unitCategory;

            if (!self.selectedUnitCategory) {
                self.setUnitCategoryEditMode(mode);
            }
        } else {
            self.selectedUnitCategory = null;
            self.setUnitCategoryEditMode(mode);
        }

        self.unitCategoryViewMode = mode;
    }

    setUnitCategoryEditMode(mode) {
        const self = this;
        let temp = angular.copy(self.unitCategoryParams);
        if (mode){
            if (self.selectedUnitCategory) {
                self.unitCategoryParams = angular.copy(self.selectedUnitCategory);
            } else {
                self.unitCategoryParams = {};
                self.unitCategoryParams.pageNo = temp.pageNo;
                self.unitCategoryParams.offset = temp.offset;
                self.unitCategoryParams.limit = temp.limit;
                self.unitCategoryParams.send_total_count = temp.send_total_count;
            }
        } else {

            self.unitCategoryParams = {};
            self.unitCategoryParams.pageNo = temp.pageNo;
            self.unitCategoryParams.offset = temp.offset;
            self.unitCategoryParams.limit = temp.limit;
            self.unitCategoryParams.send_total_count = temp.send_total_count;

            if (!self.selectedUnitCategory) {
                self.unitCategoryViewMode = mode;
            }
        }

        self.unitCategoryEditMode = mode;
    }

    saveUnitCategory() {
        let self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self._saveUnitCategory();
        });
    }

    _saveUnitCategory() {
        let self = this;

        self.SSAlertService.clear();

        if (!self.unitCategoryParams) {
            return;
        }

        let url = 'sec/super/unit-categories/';
        let params = angular.copy(self.unitCategoryParams);

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#unitCategoryForm'))) {

            self.SSAlertService.danger("Please correct the following errors before you proceed.");

                self.propertyDiscountViewMode = true;
                self.setUnitCategoryEditMode(true);
            return;
        }


        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let existingUnitCategory= self.selectedUnitCategory;
            let newUnitCategory = response.data;

            if (existingUnitCategory && existingUnitCategory.id) {
                angular.merge(existingUnitCategory, newUnitCategory);
            } else {
                self.unitCategories.push(newUnitCategory);
            }

            self.setUnitCategoryViewMode(false);
            self.setUnitCategoryViewMode(true, newUnitCategory);
        };

        loading(true);
        if (self.unitCategoryParams.id) {
            url +=  self.unitCategoryParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    deleteUnitCategory(unitCategoryId) {
        let self = this;

        if (!unitCategoryId)
            return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/super/unit-categories/'+ unitCategoryId + '/delete-unit-category';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if(response.code == 409 && response.message){
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    // Remove from local data
                    jQuery.each(self.unitCategories, function (i, o) {
                        if (o.id == unitCategoryId) {
                            self.unitCategories.splice(i, 1);
                            return false;
                        }
                    });
                });
            }
        );
    }

}

SuperUnitCategoriesController.$inject = [
    'Upload',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSAppService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('SuperUnitCategoriesController', SuperUnitCategoriesController);
